import { Blobatar } from "@blobatar/react"

import { cn } from "@/lib/utils"

/**
 * Avatar for a person: a face derived from the name, so the same user always
 * looks the same. Rooms keep the initials tile in `UserAvatar`.
 */
export function UserBlobatar({
  name,
  className,
}: {
  name: string
  className?: string
}) {
  return (
    <Blobatar
      name={name}
      animate="hover"
      className={cn("size-8 shrink-0", className)}
    />
  )
}
